import {TweenMax, Power2} from 'gsap';

export class BlockMarketingMobile {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;

  public static openEl: number;

  public static init() {

    BlockMarketingMobile.$element = $('.BlockMarketingMobile');
    BlockMarketingMobile.element = BlockMarketingMobile.$element.get(0);

    BlockMarketingMobile.openEl = 0;

    if (BlockMarketingMobile.$element.length) {
      BlockMarketingMobile.events();
    }
  }

  public static events() {
    console.log("BlockMarketingMobile");
    BlockMarketingMobile.$element.find(".BlockMarketingMobile-itemTop").on("click", function() {
      let $parent = $(this).closest(".BlockMarketingMobile-item");
      if ($parent.attr("data-status") === "open") {
        $parent.attr("data-status", "closed");
        BlockMarketingMobile.closeDropdown($parent);
      } else {
        $parent.attr("data-status", "open");
        BlockMarketingMobile.openDropdown($parent);
      }
    });
  }

  public static openDropdown($el: JQuery<HTMLElement>) {
    TweenMax.set($el.find(".BlockMarketingMobile-itemBottom"), { height: 'auto' });

    TweenMax.from($el.find(".BlockMarketingMobile-itemBottom"), 0.5, {
      height: 0,
      ease: Power2.easeOut
    });

    // rotation du svg
    TweenMax.to($el.find(".BlockMarketingMobile-dropdown svg"), 0.5, {
      rotation: 180,
      transformOrigin: "center center",
      ease: Power2.easeOut
    });
  }

  public static closeDropdown($el: JQuery<HTMLElement>) {
    TweenMax.to($el.find(".BlockMarketingMobile-itemBottom"), 0.5, {
      height: 0,
      ease: Power2.easeOut
    });

    // rotation du svg
    TweenMax.to($el.find(".BlockMarketingMobile-dropdown svg"), 0.5, {
      rotation: 0,
      transformOrigin: "center center",
      ease: Power2.easeOut
    });
  }

}
